export default {
    tradersMarkUps: [],
    tradersMarkUpsLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters,
}

function setInitialFilters() {
    return {
        kind_id: 30
    }
}